import { ComponentType } from "react";
import { OrganizationNameFragment } from "gql/graphql";
import { LocalizedName } from "@/shared/data-display/localized-value";
import { Hidable, Value } from "@/shared/value";

/** Название подразделения — см. `PositionName`, случай тот же. */
export function OrganizationName({
  data,
  whenEmpty,
}: {
  data?: Hidable<OrganizationNameFragment>;
  whenEmpty?: ComponentType;
}) {
  return (
    <Value data={data} whenEmpty={whenEmpty}>
      {(organization) => (
        <LocalizedName data={organization.name} whenEmpty={whenEmpty} />
      )}
    </Value>
  );
}
